<template>
  <main class="policy page-main">
    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('policy.head') }}</h3>
    </section>

    <section>
      <div class="policy-select link-select">
        <button
          class="link-select-button"
          type="button"
          :class="{
            'link-select-active': isPolicyShow
          }"
          @click="onBetterToggle"
        >
          <span v-if="list.length > 0 && selectList">
            <template v-if="isCurrent">
              [현행]
            </template>
            {{ selectList.personalInformationVersion }}
          </span>
          <span class="down"><icon-chevron-down /></span>
        </button>
        <transition name="link-select">
          <ul v-if="isPolicyShow" class="link-select-list">
            <li v-for="(item, key) in list" :key="key">
              <router-link
                :to="{
                  params: { id: item.personalInformationSeq }
                }"
              >
                <span v-if="key === 0">[현행]</span>
                {{ item.personalInformationVersion }}
              </router-link>
            </li>
          </ul>
        </transition>
      </div>
      <html-view v-model="content" class="policy-content editor" />
      <div class="policy-aside">
        <ul>
          <li>공고 일자 : {{ $moment(announceDay).format('YYYY년 MM월 DD일') }}</li>
          <li>시행 일자 : {{ $moment(enforceDay).format('YYYY년 MM월 DD일') }}</li>
        </ul>
      </div>
    </section>
  </main>
</template>
<script>
import personalInformationApi from '@/api/personalInformation'
import defendPath from '@/mixins/defendPath'

export default {
  components: {
    iconChevronDown: () => import('@/static/svg/chevron-down.svg')
  },
  mixins: [defendPath],
  data () {
    return {
      isPolicyShow: false,
      seq: 0,
      list: [],
      content: '',
      enforceDay: new Date(), // 시행일
      announceDay: new Date() // 공고일
    }
  },
  computed: {
    isCurrent () {
      return this.list[0].personalInformationSeq === this.selectList.personalInformationSeq
    },
    selectList () {
      if (this.$route.params.id) {
        return this.list.find(item => item.personalInformationSeq === Number(this.$route.params.id))
      }
      return this.list[0]
    }
  },
  watch: {
    '$route.params.id' (id) {
      this.isPolicyShow = false

      this.seq = id
      this.getDetail()
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    async getList () {
      const { data } = await personalInformationApi.getList()

      this.seq = Number(this.$route.params.id) || data.list[0].personalInformationSeq
      this.list = data.list

      if (this.$route.query.sharekey) {
        this.getShareDetail()
      } else {
        this.getDetail()
      }
    },
    async getDetail () {
      const { data } = await personalInformationApi.getDetail(this.seq)

      this.content = data.personalInformationContents
      this.enforceDay = data.personalInformationEnforceDay
      this.announceDay = data.personalInformationAnnounceDay
    },
    async getShareDetail () {
      const { data } = await personalInformationApi.getShareDetail({
        linkKey: this.$route.query.sharekey,
        language: this.isKorean ? 'KR' : 'EN'
      })

      this.content = data.personalInformationContents
      this.enforceDay = data.personalInformationEnforceDay
      this.announceDay = data.personalInformationAnnounceDay
    },
    onBetterToggle () {
      this.isPolicyShow = !this.isPolicyShow

      const docEvents = (e) => {
        if (!e.target.closest('.link-select')) {
          this.isPolicyShow = false
          document.documentElement.removeEventListener('click', docEvents)
        }
      }

      document.documentElement.addEventListener('click', docEvents)
    }
  }
}
</script>
